export async function useGlobalSeo(shopName: string) {
    const { apiClient } = useShopwareContext();
    const url = useRequestURL();
    const router = useRouter();
    const { getTitleTag } = useTitleTagMapping();

    const queryParams = ref({
        path: url.origin,
        param: url.pathname,
        fullPath: url.href,
    });

    const seoSpecificDataPromise = useAsyncData('seoSpecificData', async () => {
        const { data } = await apiClient.invoke('specificStructuredData get seo/specific-structured-data', {
            query: queryParams.value,
        });

        return data;
    }, { immediate: true, watch: [queryParams] });

    await seoSpecificDataPromise;

    useMeta({
        title: getTitleTag(shopName)
    });

    watch(router.currentRoute, () => {
        const currentUrl = useRequestURL();

        queryParams.value = {
            path: currentUrl.origin,
            param: currentUrl.pathname,
            fullPath: currentUrl.href,
        };

        useMeta({
            title: getTitleTag(shopName),
        });
    })
}
